import { AiChatMessage } from "components/AiChat/types";

const STORAGE_KEY = "ai-chat-messages";

const getAiChatMessages = (): AiChatMessage[] => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) {
    return [];
  }
  return JSON.parse(stored);
};

export const getInitialMessages = (): AiChatMessage[] => {
  const stored = getAiChatMessages();
  return stored.length > 0 ? stored : [];
};

export const getNewChatMessages = (): AiChatMessage[] => {
  return [];
};

export const saveAiChatMessages = (messages: AiChatMessage[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
};

export const clearAiChatMessages = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
